import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './sbg-debt-announcements.component.scss';
import axios from 'axios';
import * as $ from 'jquery';
var sensAnnouncmentsStartDate = "";
var sensAnnouncmentsEndDate = "";
var sensAnnouncmentsJson = "";
var sensAnnouncmentsDebtInstrument = false;
var SbgDebtAnnouncements = /** @class */ (function (_super) {
    tslib_1.__extends(SbgDebtAnnouncements, _super);
    function SbgDebtAnnouncements(element) {
        return _super.call(this, element) || this;
    }
    SbgDebtAnnouncements.prototype.init = function () {
        this.endpoint = 'https://df.marketdata.feeds.iress.com/feed/2844/?token=eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJzZWNJRCI6NTMyLCJpYXQiOjE3ODE4NzM5NTMsImF1ZCI6ImlyZXNzLmNvLnphIiwiaXNzIjoiYWNjb3VudHMuaXJlc3MuY28uemEifQ.39DQKGFwIJcl8z7XUe_rCfLJWAZKGV6DTjN8toVbIS5yxAemcDLZKbOf9av0xWqdm2j7-FuDgYoOZ6Noz58L7A';
        // this.endpoint = 'https://sb.imgraham.co.za/api/sens/announcements';
        this.varNewFeed = true;
        this.varSubFeed = 0;
        this.varCount = 600;
        this.varCompanyKey = 'Standard+Bank+-+Simon';
        this.varLimit = 10;
        this.varPagination = 10;
        this.varPaginationIndex = 0;
        this.varSearch = '';
        if (this.element.getAttribute('data-count')) {
            this.varCount = parseInt(this.element.getAttribute('data-count'));
        }
        if (this.element.getAttribute('data-debtinstrument')) {
            var debitInstrument = this.element.getAttribute('data-debtinstrument');
            if (debitInstrument === 'true') {
                sensAnnouncmentsDebtInstrument = true;
            }
        }
        this.containerShowing = this.element.querySelector('.sbg-debt-announcements__content--showing');
        this.containerLoader = this.element.querySelector('.sbg-debt-announcements__content--loader');
        this.containerEmpty = this.element.querySelector('.sbg-debt-announcements__content--empty');
        this.containerItems = this.element.querySelector('.sbg-debt-announcements__content--items');
        this.containerPagination = this.element.querySelector('.sbg-debt-announcements__content--pagination');
        this.buttonSearchCross = Array.from(this.element.querySelectorAll('.filter-builder__form-field--searchbuttonclear'));
        this.buttonSearch = Array.from(this.element.querySelectorAll('.js-search'));
        this.buttonPaginationItems = Array.from(this.element.querySelectorAll('.pagination__item'));
        this.buttonPaginationPrevious = this.element.querySelector('.pagination__nav--prev');
        this.buttonPaginationNext = this.element.querySelector('.pagination__nav--next');
        this.buttonApplyFilters = Array.from(this.element.querySelectorAll('.js-var-apply'));
        this.buttonClearFilters = Array.from(this.element.querySelectorAll('.js-var-reset'));
        this.form = this.element.querySelector('form');
        this.inputSearch = Array.from(this.element.querySelectorAll('.js-form-search-bar'));
        this.inputDateStart = Array.from(this.element.querySelectorAll('input.js-start-date'));
        this.inputDateEnd = Array.from(this.element.querySelectorAll('input.js-end-date'));
        $(document).ready(function () {
            // start dateppicker
            $('input.js-start-date').datepicker({
                format: "dd/mm/yyyy",
                todayHighlight: true,
                enableOnReadonly: true,
                autoclose: true
            }).on('changeDate', function (e) {
                var datePast = e.date;
                var datePastYear = datePast.getFullYear();
                var datePastMonth = (datePast.getMonth() + 1).toString().padStart(2, "0");
                var datePastDate = datePast.getDate().toString().padStart(2, "0");
                var datePastFormatted = datePastDate + '/' + datePastMonth + '/' + datePastYear;
                sensAnnouncmentsStartDate = datePastFormatted;
                var dateFuture = e.date;
                dateFuture.setDate(dateFuture.getDate() + 1);
                var dateFutureYear = dateFuture.getFullYear();
                var dateFutureMonth = (dateFuture.getMonth() + 1).toString().padStart(2, "0");
                var dateFutureDate = dateFuture.getDate().toString().padStart(2, "0");
                var dateFutureFormatted = dateFutureDate + '/' + dateFutureMonth + '/' + dateFutureYear;
                $('input.js-end-date').datepicker('setStartDate', dateFutureFormatted);
                $('input.js-end-date').prop('disabled', false);
            });
            // end dateppicker
            $('input.js-end-date').datepicker({
                format: "dd/mm/yyyy",
                todayHighlight: true,
                enableOnReadonly: true,
                autoclose: true
            }).on('changeDate', function (e) {
                var dateFuture = e.date;
                var dateFutureYear = dateFuture.getFullYear();
                var dateFutureMonth = (dateFuture.getMonth() + 1).toString().padStart(2, "0");
                var dateFutureDate = dateFuture.getDate().toString().padStart(2, "0");
                var dateFutureFormatted = dateFutureDate + '/' + dateFutureMonth + '/' + dateFutureYear;
                sensAnnouncmentsEndDate = dateFutureFormatted;
                var datePast = e.date;
                datePast.setDate(datePast.getDate() - 1);
                var datePastYear = datePast.getFullYear();
                var datePastMonth = (datePast.getMonth() + 1).toString().padStart(2, "0");
                var datePastDate = datePast.getDate().toString().padStart(2, "0");
                var datePastFormatted = datePastDate + '/' + datePastMonth + '/' + datePastYear;
                $('input.js-start-date').datepicker('setEndDate', datePastFormatted);
            });
            var dateEnd = new Date();
            var dateEndYear = dateEnd.getFullYear();
            var dateEndMonth = (dateEnd.getMonth() + 1).toString().padStart(2, "0");
            var dateEndDate = dateEnd.getDate().toString().padStart(2, "0");
            var dateEndFormatted = dateEndDate + '/' + dateEndMonth + '/' + dateEndYear;
            $('input.js-start-date').datepicker('setEndDate', dateEndFormatted);
            $('input.js-end-date').datepicker('setEndDate', dateEndFormatted);
        });
        this.loadAnnouncements(this.varLimit);
    };
    SbgDebtAnnouncements.prototype.bindEvents = function () {
        var _this = this;
        if (this.inputSearch) {
            this.inputSearch.map(function (item) { return item.addEventListener('keyup', function (event) {
                var element = undefined;
                if (event.target) {
                    element = event.target;
                }
                var value = element.value;
                _this.varSearch = value.toLowerCase();
                var container = element.closest('.filter-builder__form-field--container');
                var clear = container.querySelector('.filter-builder__form-field--searchbuttonclear');
                if (value.length > 0) {
                    clear.classList.remove('d-none');
                }
                else {
                    clear.classList.add('d-none');
                }
            }); });
        }
        if (this.buttonSearchCross) {
            this.buttonSearchCross.map(function (item) { return item.addEventListener('click', function (event) {
                item.classList.add('d-none');
                _this.inputSearch.map(function (input) {
                    input.value = "";
                });
            }); });
        }
        if (this.buttonSearch) {
            this.buttonSearch.map(function (item) { return item.addEventListener('click', function (event) {
                _this.varPaginationIndex = 0;
                _this.containerShowing.classList.add('d-none');
                _this.containerItems.classList.add('d-none');
                _this.containerPagination.classList.add('d-none');
                _this.containerEmpty.classList.add('d-none');
                _this.containerLoader.classList.remove('d-none');
                setTimeout(function () {
                    _this.containerShowing.classList.add('d-none');
                    _this.containerItems.classList.add('d-none');
                    _this.containerPagination.classList.add('d-none');
                    _this.containerEmpty.classList.add('d-none');
                    _this.containerLoader.classList.add('d-none');
                    _this.generateLayout(_this.containerShowing, _this.containerItems, _this.containerEmpty, _this.containerLoader, _this.containerPagination, parseInt(_this.varPaginationIndex), _this.buttonPaginationPrevious, _this.buttonPaginationNext, _this.varLimit, _this.varJsonOriginal, _this.varSearch, _this.varDateStart, _this.varDateEnd, _this.generateItems, _this.generatePagination, sensAnnouncmentsDebtInstrument);
                }, 2000);
            }); });
        }
        $(document).on('click', 'li.pagination__item', function (e) {
            // window.scrollTo(0, 0);
            var target = e.target;
            var page = parseInt(target.getAttribute('data-page'));
            _this.varPaginationIndex = parseInt(page);
            var items = Array.from(_this.containerItems.querySelectorAll('.sbg-debt-announcements__item'));
            items.forEach(function (item) {
                var getPage = parseInt(item.getAttribute('data-page'));
                item.classList.add('d-none');
                if (getPage === page) {
                    item.classList.remove('d-none');
                }
            });
            // ✅ ADD SCROLL HERE
            _this.containerItems.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            _this.generatePagination(_this.containerPagination, _this.varLimit, sensAnnouncmentsJson.length, parseInt(_this.varPaginationIndex), _this.buttonPaginationPrevious, _this.buttonPaginationNext);
        });
        this.buttonPaginationPrevious.addEventListener('click', function (e) {
            if (!_this.buttonPaginationPrevious.classList.contains('pagination__nav--disabled')) {
                // window.scrollTo(0, 0);
                _this.varPaginationIndex = _this.varPaginationIndex - 1;
                _this.generatePagination(_this.containerPagination, _this.varLimit, sensAnnouncmentsJson.length, parseInt(_this.varPaginationIndex), _this.buttonPaginationPrevious, _this.buttonPaginationNext);
                if (_this.element.querySelector('.pagination__item--active')) {
                    var element = _this.element.querySelector('.pagination__item--active');
                    var page_1 = parseInt(element.getAttribute('data-page'));
                    var items = Array.from(_this.containerItems.querySelectorAll('.sbg-debt-announcements__item'));
                    items.forEach(function (item) {
                        var getPage = parseInt(item.getAttribute('data-page'));
                        item.classList.add('d-none');
                        if (getPage === page_1) {
                            item.classList.remove('d-none');
                        }
                    });
                }
            }
        });
        this.buttonPaginationNext.addEventListener('click', function (e) {
            if (!_this.buttonPaginationNext.classList.contains('pagination__nav--disabled')) {
                // window.scrollTo(0, 0);
                _this.varPaginationIndex = _this.varPaginationIndex + 1;
                _this.generatePagination(_this.containerPagination, _this.varLimit, sensAnnouncmentsJson.length, parseInt(_this.varPaginationIndex), _this.buttonPaginationPrevious, _this.buttonPaginationNext);
                if (_this.element.querySelector('.pagination__item--active')) {
                    var element = _this.element.querySelector('.pagination__item--active');
                    var page_2 = parseInt(element.getAttribute('data-page'));
                    var items = Array.from(_this.containerItems.querySelectorAll('.sbg-debt-announcements__item'));
                    items.forEach(function (item) {
                        var getPage = parseInt(item.getAttribute('data-page'));
                        item.classList.add('d-none');
                        if (getPage === page_2) {
                            item.classList.remove('d-none');
                        }
                    });
                }
            }
        });
        this.buttonApplyFilters.map(function (button) { return button.addEventListener('click', function (event) {
            // check modal
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            if (element.closest('#modal-advanced-filters')) {
                var modal = element.closest('#modal-advanced-filters');
                modal.classList.add('modal--close');
                modal.classList.add('modal--closed');
            }
            _this.varPaginationIndex = 0;
            _this.varDateStart = sensAnnouncmentsStartDate;
            _this.varDateEnd = sensAnnouncmentsEndDate;
            _this.containerShowing.classList.add('d-none');
            _this.containerItems.classList.add('d-none');
            _this.containerPagination.classList.add('d-none');
            _this.containerEmpty.classList.add('d-none');
            _this.containerLoader.classList.remove('d-none');
            setTimeout(function () {
                _this.containerShowing.classList.add('d-none');
                _this.containerItems.classList.add('d-none');
                _this.containerPagination.classList.add('d-none');
                _this.containerEmpty.classList.add('d-none');
                _this.containerLoader.classList.add('d-none');
                _this.generateLayout(_this.containerShowing, _this.containerItems, _this.containerEmpty, _this.containerLoader, _this.containerPagination, parseInt(_this.varPaginationIndex), _this.buttonPaginationPrevious, _this.buttonPaginationNext, _this.varLimit, _this.varJsonOriginal, _this.varSearch, _this.varDateStart, _this.varDateEnd, _this.generateItems, _this.generatePagination, sensAnnouncmentsDebtInstrument);
            }, 2000);
        }); });
        this.buttonClearFilters.map(function (button) { return button.addEventListener('click', function (event) {
            // check modal
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            if (element.closest('#modal-advanced-filters')) {
                var modal = element.closest('#modal-advanced-filters');
                modal.classList.add('modal--close');
                modal.classList.add('modal--closed');
            }
            // remove cross
            if (_this.buttonSearchCross) {
                _this.buttonSearchCross.map(function (item) {
                    item.classList.add('d-none');
                });
            }
            $('input.js-end-date').prop('disabled', true);
            _this.form.reset();
            _this.varPaginationIndex = 0;
            _this.varSearch = "";
            _this.varDateStart = "";
            _this.varDateEnd = "";
            _this.varJson = _this.varJsonOriginal;
            sensAnnouncmentsJson = _this.varJsonOriginal;
            _this.containerShowing.classList.add('d-none');
            _this.containerItems.classList.add('d-none');
            _this.containerPagination.classList.add('d-none');
            _this.containerEmpty.classList.add('d-none');
            _this.containerLoader.classList.remove('d-none');
            setTimeout(function () {
                _this.containerShowing.classList.add('d-none');
                _this.containerItems.classList.add('d-none');
                _this.containerPagination.classList.add('d-none');
                _this.containerEmpty.classList.add('d-none');
                _this.containerLoader.classList.add('d-none');
                _this.generateLayout(_this.containerShowing, _this.containerItems, _this.containerEmpty, _this.containerLoader, _this.containerPagination, parseInt(_this.varPaginationIndex), _this.buttonPaginationPrevious, _this.buttonPaginationNext, _this.varLimit, _this.varJsonOriginal, _this.varSearch, _this.varDateStart, _this.varDateEnd, _this.generateItems, _this.generatePagination, sensAnnouncmentsDebtInstrument);
            }, 2000);
        }); });
        if (this.form) {
            this.form.addEventListener('submit', function (event) {
                event.preventDefault();
                _this.varPaginationIndex = 0;
                _this.containerShowing.classList.add('d-none');
                _this.containerItems.classList.add('d-none');
                _this.containerPagination.classList.add('d-none');
                _this.containerEmpty.classList.add('d-none');
                _this.containerLoader.classList.remove('d-none');
                setTimeout(function () {
                    _this.containerShowing.classList.add('d-none');
                    _this.containerItems.classList.add('d-none');
                    _this.containerPagination.classList.add('d-none');
                    _this.containerEmpty.classList.add('d-none');
                    _this.containerLoader.classList.add('d-none');
                    _this.generateLayout(_this.containerShowing, _this.containerItems, _this.containerEmpty, _this.containerLoader, _this.containerPagination, parseInt(_this.varPaginationIndex), _this.buttonPaginationPrevious, _this.buttonPaginationNext, _this.varLimit, _this.varJsonOriginal, _this.varSearch, _this.varDateStart, _this.varDateEnd, _this.generateItems, _this.generatePagination, sensAnnouncmentsDebtInstrument);
                }, 2000);
            });
        }
    };
    SbgDebtAnnouncements.prototype.loadAnnouncements = function (limit, offset) {
        var _this = this;
        if (limit === void 0) { limit = 10; }
        if (offset === void 0) { offset = 0; }
        var endpoint = this.endpoint;
        var varNewFeed = this.varNewFeed;
        var varSubFeed = this.varSubFeed;
        var varCount = this.varCount;
        var varCompanyKey = this.varCompanyKey;
        var varLimit = this.varLimit;
        var varPaginationIndex = this.varPaginationIndex;
        var varJson = this.varJson;
        var varSearch = this.varSearch;
        var containerShowing = this.containerShowing;
        var containerLoader = this.containerLoader;
        var containerEmpty = this.containerEmpty;
        var containerItems = this.containerItems;
        var containerPagination = this.containerPagination;
        var buttonPaginationPrevious = this.buttonPaginationPrevious;
        var buttonPaginationNext = this.buttonPaginationNext;
        var inputSearch = this.inputSearch;
        var inputDateStart = this.inputDateStart;
        var inputDateEnd = this.inputDateEnd;
        var generateItems = this.generateItems;
        var generatePagination = this.generatePagination;
        var generateLayout = this.generateLayout;
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var newEndpoint = endpoint;
        // let newEndpoint: any = endpoint+'?newfeed='+varNewFeed+'&SubFeed='+varSubFeed+'&CompanyKey='+varCompanyKey+'&count='+varCount;
        if (varSearch) {
            newEndpoint = newEndpoint + '&keyword=' + varSearch;
        }
        // let newEndpoint: any = endpoint+'?newfeed='+varNewFeed+'&SubFeed='+varSubFeed+'&CompanyKey='+varCompanyKey+'&count='+varCount;
        axios.get(newEndpoint).then(function (response) {
            inputSearch.map(function (item) {
                item.removeAttribute('disabled');
            });
            inputDateStart.map(function (item) {
                item.removeAttribute('disabled');
            });
            // inputDateEnd.map((item: any) => {
            // 	item.removeAttribute('disabled');
            // })
            var json = response.data.News;
            var results = json;
            _this.varJson = results;
            _this.varJsonOriginal = results;
            sensAnnouncmentsJson = results;
            generateLayout(containerShowing, containerItems, containerEmpty, containerLoader, containerPagination, parseInt(varPaginationIndex), buttonPaginationPrevious, buttonPaginationNext, varLimit, results, "", "", "", generateItems, generatePagination, sensAnnouncmentsDebtInstrument);
        }).catch(function (error) {
            console.log(error);
        });
    };
    SbgDebtAnnouncements.prototype.generateLayout = function (containerShowing, containerItems, containerEmpty, containerLoader, containerPagination, varPaginationIndex, paginationControlPrev, paginationControlNext, limit, json, search, dateStart, dateEnd, generateItems, generatePagination, debitInstrument) {
        if (containerShowing === void 0) { containerShowing = ""; }
        if (containerItems === void 0) { containerItems = ""; }
        if (containerEmpty === void 0) { containerEmpty = ""; }
        if (containerLoader === void 0) { containerLoader = ""; }
        if (containerPagination === void 0) { containerPagination = ""; }
        if (varPaginationIndex === void 0) { varPaginationIndex = 0; }
        if (paginationControlPrev === void 0) { paginationControlPrev = ""; }
        if (paginationControlNext === void 0) { paginationControlNext = ""; }
        if (limit === void 0) { limit = 10; }
        if (json === void 0) { json = []; }
        if (search === void 0) { search = ""; }
        if (dateStart === void 0) { dateStart = ""; }
        if (dateEnd === void 0) { dateEnd = ""; }
        if (generateItems === void 0) { generateItems = ""; }
        if (generatePagination === void 0) { generatePagination = ""; }
        if (debitInstrument === void 0) { debitInstrument = false; }
        if (json.length === 0) {
            containerShowing.classList.add('d-none');
            containerItems.classList.add('d-none');
            containerPagination.classList.add('d-none');
            containerLoader.classList.add('d-none');
            containerEmpty.classList.remove('d-none');
        }
        else {
            var arrayNew = [];
            var arrayOriginal = json;
            var arraySearch_1 = [];
            var arrayDateStart_1 = [];
            var arrayDateEnd_1 = [];
            var arrayFilter_1 = [];
            var empty = true;
            // search
            if (search) {
                arrayOriginal.forEach(function (item) {
                    var itemName = item.Header.toLowerCase();
                    if (itemName.includes(search)) {
                        arraySearch_1.push(item);
                    }
                });
            }
            else {
                arraySearch_1 = arrayOriginal;
            }
            // search
            // date start
            if (dateStart) {
                var dateStartStripped = dateStart.split('/');
                var convertDateStart_1 = new Date(dateStartStripped[2], dateStartStripped[1] - 1, dateStartStripped[0]);
                arraySearch_1.forEach(function (item) {
                    var itemDateStamp = item.DateStamp;
                    if (itemDateStamp.includes('/')) {
                        var itemDateStampStripped = itemDateStamp.split('/');
                        var convertItemDateStart = new Date(itemDateStampStripped[0], itemDateStampStripped[1] - 1, itemDateStampStripped[2]);
                        if (convertDateStart_1 <= convertItemDateStart) {
                            arrayDateStart_1.push(item);
                        }
                    }
                    else {
                        var itemDateStampStripped = itemDateStamp.split('-');
                        var convertItemDateStart = new Date(itemDateStampStripped[0], itemDateStampStripped[1] - 1, itemDateStampStripped[2]);
                        if (convertDateStart_1 <= convertItemDateStart) {
                            arrayDateStart_1.push(item);
                        }
                    }
                });
            }
            else {
                arrayDateStart_1 = arraySearch_1;
            }
            // date start
            // date end
            if (dateEnd) {
                var dateEndStripped = dateEnd.split('/');
                var convertDateEnd_1 = new Date(dateEndStripped[2], dateEndStripped[1] - 1, dateEndStripped[0]);
                arrayDateStart_1.forEach(function (item) {
                    var itemDateStamp = item.DateStamp;
                    if (itemDateStamp.includes('/')) {
                        var itemDateStampStripped = itemDateStamp.split('/');
                        var convertItemDateEnd = new Date(itemDateStampStripped[0], itemDateStampStripped[1] - 1, itemDateStampStripped[2]);
                        if (convertDateEnd_1 >= convertItemDateEnd) {
                            arrayDateEnd_1.push(item);
                        }
                    }
                    else {
                        var itemDateStampStripped = itemDateStamp.split('-');
                        var convertItemDateEnd = new Date(itemDateStampStripped[0], itemDateStampStripped[1] - 1, itemDateStampStripped[2]);
                        if (convertDateEnd_1 >= convertItemDateEnd) {
                            arrayDateEnd_1.push(item);
                        }
                    }
                });
            }
            else {
                arrayDateEnd_1 = arrayDateStart_1;
            }
            // date end
            // filter
            arrayDateEnd_1.forEach(function (item) {
                // const headerString: string = item.Header.toLowerCase();
                // // Check if the header starts with 'sbki'
                // if (headerString.startsWith('sbki')) {
                // 	return; // Skip this item
                // }
                // // Check if the header starts with 'sbkh'
                // if (headerString.startsWith('sbkh')) {
                // 	return; // Skip this item
                // }
                // // Filter based on debitInstrument and 'sbk - '
                // if (debitInstrument && headerString.includes('sbk - ')) {
                // 	arrayFilter.push(item);
                // } else if (!debitInstrument && !headerString.includes('sbk - ')) {
                // 	arrayFilter.push(item);
                // }
                arrayFilter_1.push(item);
            });
            // filter
            // empty / not
            arrayNew = arrayFilter_1;
            sensAnnouncmentsJson = arrayNew;
            if (arrayNew.length === 0) {
                containerShowing.classList.add('d-none');
                containerItems.classList.add('d-none');
                containerPagination.classList.add('d-none');
                containerLoader.classList.add('d-none');
                containerEmpty.classList.remove('d-none');
            }
            else {
                var getShowingVar = containerShowing.querySelector('.js-var-showing');
                if (sensAnnouncmentsJson.length === 1) {
                    getShowingVar.innerHTML = sensAnnouncmentsJson.length + ' announcement';
                }
                else {
                    getShowingVar.innerHTML = sensAnnouncmentsJson.length + ' announcements';
                }
                generateItems(containerItems, arrayNew, limit, arrayNew.length);
                generatePagination(containerPagination, limit, arrayNew.length, parseInt(varPaginationIndex), paginationControlPrev, paginationControlNext);
                containerLoader.classList.add('d-none');
                containerShowing.classList.remove('d-none');
            }
            // empty / not
        }
    };
    SbgDebtAnnouncements.prototype.generateItems = function (container, json, limit, total) {
        var output = '';
        var indexPage = 0;
        var indexItem = 0;
        var indexContent = 0;
        var calculate = parseInt(total) / parseInt(limit);
        var times = calculate.toString().includes('.') ? Math.ceil(calculate) : calculate;
        json.forEach(function (item) {
            var pipedHeader = item.Header.replace(/-/g, '-').toLowerCase();
            var debtInstrumentHeader = item.Header;
            if (sensAnnouncmentsDebtInstrument) {
                debtInstrumentHeader = debtInstrumentHeader.replace(/DEBT INSTRUMENT - /g, '');
                var splitDash = debtInstrumentHeader.split('-');
                var restDash = debtInstrumentHeader.substring(debtInstrumentHeader.indexOf('-'));
                if (splitDash[0].includes('|')) {
                    debtInstrumentHeader = splitDash[0].trim().split('|')[0] + ' ' + restDash;
                }
            }
            // Check if PDFDocumentLink exists or not
            var pdfLink = item.PDFDocumentLink ? item.PDFDocumentLink : '#';
            var isLinkAvailable = item.PDFDocumentLink ? true : false;
            var isHidden = indexItem >= limit ? 'd-none' : '';
            output += "\n\t\t\t\t<div class=\"sbg-debt-announcements__item " + isHidden + "\" data-page=\"" + indexPage + "\">\n\t\t\t\t\t<span class=\"sbg-debt-announcements__item--title\">\n\t\t\t\t\t\t" + (isLinkAvailable
                ? "<a href=\"" + pdfLink + "\" target=\"_blank\" class=\"link\" data-intent=\"Informational\" data-scope=\"sbg debt announcements\" data-id=\"link_content\" data-text=\"" + pipedHeader + " | title click\">\n\t\t\t\t\t\t\t\t" + debtInstrumentHeader + "\n\t\t\t\t\t\t\t  </a>"
                : "<span class=\"no-link\">" + debtInstrumentHeader + "</span>") + "\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class=\"sbg-debt-announcements__item--meta\">\n\t\t\t\t\t\t<span class=\"sbg-debt-announcements__item--meta__location\">\n\t\t\t\t\t\t\tPublication date: " + item.DateStamp + " " + item.TimeStamp + "\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t";
            indexContent++;
            indexItem++;
            if (indexContent === limit) {
                indexContent = 0;
                indexPage++;
            }
        });
        container.innerHTML = output;
        container.classList.remove('d-none');
    };
    SbgDebtAnnouncements.prototype.generatePagination = function (container, limit, total, paginationIndex, paginationControlPrev, paginationControlNext) {
        if (container === void 0) { container = ""; }
        if (limit === void 0) { limit = 10; }
        if (total === void 0) { total = 0; }
        if (paginationIndex === void 0) { paginationIndex = 0; }
        if (paginationControlPrev === void 0) { paginationControlPrev = ""; }
        if (paginationControlNext === void 0) { paginationControlNext = ""; }
        container.classList.remove('d-none');
        var pagination = container.querySelector('.pagination__items');
        var calculate = parseInt(total) / parseInt(limit);
        var times = 0;
        if (calculate.toString().indexOf('.') > -1) {
            var number = parseInt(calculate.toString().split(".")[0]);
            times = number + 1;
        }
        else {
            times = calculate;
        }
        var output = "";
        for (var index = 0; index < times; index++) {
            if (paginationIndex === 0) {
                paginationControlPrev.classList.add('pagination__nav--disabled');
                paginationControlNext.classList.remove('pagination__nav--disabled');
                if (index === 0) {
                    output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === 1) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === 2) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else {
                    output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
            }
            else if (paginationIndex === (times - 1)) {
                paginationControlPrev.classList.remove('pagination__nav--disabled');
                paginationControlNext.classList.add('pagination__nav--disabled');
                if (index === times) {
                    output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === (times - 1)) {
                    output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === (times - 2)) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === (times - 3)) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else {
                    output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
            }
            else {
                paginationControlPrev.classList.remove('pagination__nav--disabled');
                paginationControlNext.classList.remove('pagination__nav--disabled');
                var getPrevious = parseInt(paginationIndex) - 1;
                var getCurrent = parseInt(paginationIndex);
                var getNext = parseInt(paginationIndex) + 1;
                if (index === getPrevious) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === getCurrent) {
                    output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === getNext) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else {
                    output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
            }
        }
        if (times === 1) {
            paginationControlNext.classList.add('pagination__nav--disabled');
        }
        pagination.innerHTML = output;
    };
    return SbgDebtAnnouncements;
}(Base));
export { SbgDebtAnnouncements };



//////////////////
// WEBPACK FOOTER
// ./components/sbg-debt-announcements/sbg-debt-announcements.component.ts
// module id = 773
// module chunks = 0